import { Platform } from "react-native";

export async function uriToBlob(uri: string, name: string = "file") {
  if (Platform.OS === "web") {
    return fetch(uri).then((r) => r.blob());
  } else if (Platform.OS === "android") {
    return fetch(uri)
      .then((r) => r.blob())
      .then((b) => ({ uri, name, type: b.type }));
  } else {
    return { uri, name };
  }
}
